import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MBTI } from 'src/app/interfaces/mbti';
import { AskService } from 'src/app/services/ask/ask.service';
import { LogService } from 'src/app/services/log/log.service';
import { MbtiService } from 'src/app/services/mbti/mbti.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';
import { isBadWord } from 'src/utils/badword-filter';

@Component({
  selector: 'app-ask-create',
  templateUrl: './ask-create.component.html',
  styleUrls: ['./ask-create.component.scss'],
})
export class AskCreateComponent implements OnInit, OnDestroy {

  constructor(
    private modalService: ModalService, 
    private askService: AskService,
    private snackbarService: SnackbarService,
    private logService: LogService,
    private mbtiService: MbtiService
  ) { }

  @Input() from: 'home' | 'ask_post_detail' = 'home';
  type: 'mbti' | 'content' = 'mbti';
  selectedMbti: MBTI | undefined; // mbti input(select)
  inputValue = ''; // content input
  mbtiList: MBTI[] = Object.keys(MBTI) as MBTI[];
  dismissed = false;
  private askCreateDismissSubscription: Subscription | undefined;
  private created = false;

  get myMbti(): MBTI | undefined {
    return this.mbtiService.myMbti ?? undefined;
  }

  ngOnInit() {
    this.askNewPostMbtiSelectViewedLogging();
    this.askCreateDismissSubscription = this.askService.getAskCreateDismissSubject().subscribe(() => {
      this.dismissed = true;
    });
  }

  ngOnDestroy() {
    if (this.askCreateDismissSubscription !== undefined) {
      this.askCreateDismissSubscription.unsubscribe();
    }
    if (this.type === 'mbti') {
      this.askNewPostMbtiSelectDismissedLogging();
    } else if (!this.created) {
      this.askNewPostContentInputDismissedLogging();
    }
  }

  onSelectedMbti(value: string): void {
    this.selectedMbti = value as MBTI;
    this.askNewPostMbtiSelectedLogging(this.selectedMbti);
  }

  onNextClick(): void {
    if (this.selectedMbti) {
      this.type = 'content';
      this.askNewPostContentInputViewedLogging();
    }
  }

  onClickSelect(): void {
    this.askNewPostMbtiPickerOpenedLogging();
  }

  onClickSubmit(): void {
    if (!this.selectedMbti || !this.inputValue) {
      return;
    }
    this.askNewPostPostSubmitClickedLogging();
    this.createPost(this.selectedMbti, this.inputValue);
  }

  private createPost(mbti: MBTI, content: string): void {
    if (isBadWord(content)) {
      this.snackbarService.openSnackBar(SnackbarService.CONTAINS_BADWORD);
      return;
    }
    this.askService.createPost(mbti, content).subscribe(() => {
      this.created = true;
      this.modalService.dismiss()
    }, error => {
      this.modalService.dismiss()
    })
  }

  /** 이하 로깅 메소드들 */
  private askNewPostMbtiSelectViewedLogging(): void {
    if (!this.myMbti) {
      return;
    }
    this.logService.ask.askNewPostMbtiSelectViewed({
      screenName: this.from,
      userMbti: this.myMbti
    })
  }

  private askNewPostMbtiPickerOpenedLogging(): void {
    if (!this.myMbti) {
      return;
    }
    this.logService.ask.askNewPostMbtiPickerOpened({
      screenName: this.from,
      userMbti: this.myMbti
    })
  }

  private askNewPostMbtiSelectedLogging(selectedMbti: MBTI): void { 
    if (!this.myMbti) {
      return;
    }
    this.logService.ask.askNewPostMbtiSelected({
      screenName: this.from,
      userMbti: this.myMbti,
      targetMbti: selectedMbti
    })
  }

  private askNewPostMbtiSelectDismissedLogging(): void {
    if (!this.myMbti) {
      return;
    }
    this.logService.ask.askNewPostMbtiSelectDismissed({
      screenName: this.from,
      userMbti: this.myMbti,
      targetMbti: this.selectedMbti
    })
  }

  private askNewPostContentInputViewedLogging(): void {
    if (!this.myMbti || !this.selectedMbti) {
      return;
    }
    this.logService.ask.askNewPostContentInputViewed({
      screenName: this.from,
      userMbti: this.myMbti,
      targetMbti: this.selectedMbti
    });
  }

  private askNewPostPostSubmitClickedLogging(): void {
    if (!this.myMbti || !this.selectedMbti) {
      return;
    }
    this.logService.ask.askNewPostPostSubmitClicked({
      screenName: this.from,
      userMbti: this.myMbti,
      targetMbti: this.selectedMbti,
      contentLength: this.inputValue.length
    });
  }

  private askNewPostContentInputDismissedLogging(): void {
    if (!this.myMbti || !this.selectedMbti) {
      return;
    }
    this.logService.ask.askNewPostContentInputDismissed({
      screenName: this.from,
      userMbti: this.myMbti,
      targetMbti: this.selectedMbti,
      contentLength: this.inputValue.length
    });
  }
}
